













import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import UserMixin from "@mixins/UserMixin";

@Component({
  name: "UserIcon"
})
export default class UserIcon extends Mixins(UserMixin) {
  @Prop({default: false}) isOnline: boolean;
  get styles() {
    return {
      background: this.profileColor
    }
  }
}

